// What to do with the newsletter.
//
// Wave 13 (session 46). The Wave 11 rule: wherever there is a Download button,
// the instructions are beside it. This is the newsletter's version of
// PostingInstructions: a button next to Download newsletter that opens the
// steps in place, so nobody has to download first to find out what it is for.
//
// Session 53 (Wave 15a): the newsletter is also email code now. The PDF stays
// (Leena, 2026-10-12: the client reads it, then uses it in their own email
// tool however they like); the Email code menu beside it gives the same
// newsletter as a file to import into Mailchimp or any other tool. Nothing is
// sent by us, there is no list here, and there is nothing to approve.
//
// Client-facing copy: drafts, approved by Leena in one pass over the preview
// (Standing Decisions 6b). No em dashes. The Mailchimp step names what
// Mailchimp shows (Leena's test, 2026-10-14): Code your own offers Paste in
// code, Import ZIP and Import from URL. The download is a zip so Import ZIP
// takes it as it is; Paste in code is given as the fallback, with the warning
// that a double-clicked .html opens as a page, not as code (session 53 review).
import { useState } from 'react';

const STEPS = [
  {
    head: 'Read it first',
    body: 'Open the PDF, or choose Preview in browser under Email code. Everything in it comes '
        + 'from the post you approved: a short summary, three points to take away, and a button '
        + 'that links to the full post. Your logo, colours and call to action are the ones you '
        + 'chose when you set up.',
  },
  {
    head: 'If you send with Mailchimp',
    body: 'Under Email code, download For Mailchimp (zip). In Mailchimp, start a new email, choose '
        + 'Code your own, then Import ZIP, and pick the zip file you downloaded. Your pictures and '
        + 'the unsubscribe link are already in place. Change any wording you like, then send it to '
        + 'your audience as usual. If Import ZIP does not take it, unzip the file, open the '
        + '.html inside with a text editor such as Notepad (not by double-clicking it), copy '
        + 'everything and paste it in.',
  },
  {
    head: 'If you send with anything else',
    body: 'Download For any email tool and import it wherever your tool takes your own HTML: '
        + 'Constant Contact calls it Custom code, Klaviyo and Brevo have an HTML editor, and most '
        + 'others have one too. Your tool adds its own unsubscribe link. Or attach the PDF to a '
        + 'plain email.',
  },
  {
    head: 'Send it',
    body: 'To your own list, from your own tool, when you are ready. We do not send '
        + 'anything and we do not hold your subscribers.',
  },
];

export default function NewsletterInstructions() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="btn" aria-expanded={open}
              onClick={() => setOpen((v) => !v)}>
        {open ? 'Hide the instructions' : 'What to do with it'}
      </button>
      {open && (
        <section className="posting-steps">
          <h3>Using your newsletter</h3>
          <p className="hint">
            About five minutes. One newsletter is made for every post that goes out, as a PDF
            and as email code, and it is yours to send however you like.
          </p>
          <ol>
            {STEPS.map((s, i) => (
              <li key={i}>
                <strong>{s.head}.</strong> {s.body}
              </li>
            ))}
          </ol>
          <p className="hint">
            If something in it reads wrong, reply to our email and we will sort it out.
          </p>
        </section>
      )}
    </>
  );
}
